import { useSession } from 'next-auth/react';

export default function useShowAdContainers(): boolean {
  const { data: session, status: sessionStatus } = useSession();

  return sessionStatus === 'loading' || !session?.user.enabledFeatures.noAds;
}
